enum NotesAction {
  FETCH_ALL = 'notes/fetchAll',
  ADD_NOTE = 'notes/addNote'
}

export default NotesAction;
